import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    diagnosis: yup.string().required('Campo obligatorio'),
  })
  .required()
